import axios, { AxiosError, AxiosResponse } from 'axios';
import { socket } from './contexts/socket';
import { useISUContext } from './App';

export interface UserInfo {
    status: string;
    Id: number;
    Title: string;
    FirstName: string;
    MiddleName: string;
    LastName: string;
    Email: string;
    Affiliation: string;
    WorkArea: string;
    Interests: string;
    Street: string;
    City: string;
    State: string;
    Country: string;
    Zip: string;
    Phone: string;
    Fax: string;
    URL: string;
    ModDate: string;
    Exposed: string;
    username: string;
    resetcode: number;
    AllocInst: string;
    BadEmail: string;
    Category: string;
}

export interface ScheduleByUserEntry {
    SchedId: string,
    Date: string,
    TelNr: string,
    StartTIme: string,
    EndTime: string,
    Instrument: string,
    Account: string,
    ProjCode: string,
    Institution: string,
    Principal: string,
    Observers: string,
    ObsId: string,
    Length: number,
    FractionOfNIght: number,
    Semester: string
}

export interface ScheduleEntry {
    SchedId: string,
    Date: string,
    TelNr: string,
    Instrument: string,
    Account: string,
    Institution: string,
    ProjCode: string,
    StartTime: string,
    EndTime: string,
    PiID: string,
    PiLastName: string,
    PiFirstName: string,
    PiEmail: string,
    Principal: string,
    Comment: string,
    Observers: string,
    Location: string,
    ObsId: string,
    Length: number,
    FractionOfNight: number,
    Semester: string
}

export function handleResponse(response: AxiosResponse) {
    if (response.data) {
        return response.data;
    }
    return response;
}

export function handleError(error: Error | AxiosError) {
    if (axios.isAxiosError(error)) {
        return error.toJSON();
    }
    return error;
}

export const get_testSemids = (): Promise<UserInfo> => {
    const url = 'testSemids';
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError)
}

export const get_userinfo = (): Promise<UserInfo> => {
    const url = '/userinfo';
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError)
}

export const get_userinfo_API = (): Promise<UserInfo> => {
    const url = 'token';
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError)
}

export const get_payload_API = (token:string): Promise<UserInfo> => {
    const url = '/get_payload';
    return axios.get(url, {headers: {'Authorization': `Bearer ${token}` }})
        .then(handleResponse)
        .catch(handleError)
}

export const get_schedule_by_user = (userid: number): Promise<ScheduleByUserEntry[]> => {
    let url = `cgi-bin/PIAccess/nph-PIAccess.py?request=GET_SEMIDS_PER_USER&PI=koaadmin&alt_format=ProjCode`
    url += `&user=${userid}`
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError)
}

export const get_schedule = (date: string): Promise<ScheduleEntry[]> => {
    let url = `/api/telSchedule?cmd=getSchedule`
    url += `&date=${date}`
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError)
}

export const get_file = (file_locator: string, token: string, ofname_flag: boolean) => {
    let url = `/get_file/${file_locator}`;
    console.warn(`Retrieving ${file_locator}`);

    return axios.get(url, {headers: {'Authorization': `Bearer ${token}` }})
        .then((data: AxiosResponse) => {
            console.log(data)
        })
        .catch(handleError)
}
